import React from "react";
import StepperStyles from "./Stepper.module.scss";
import { CheckOutlined } from "@ant-design/icons";

interface CustomStepperProps {
  currentStep: number;
}

const CustomStepper: React.FC<CustomStepperProps> = ({ currentStep }) => {
  const steps = [
    {
      number: 1,
      status:
        currentStep >= 0
          ? currentStep > 0
            ? "completed"
            : "active"
          : "pending",
    },
    {
      number: 2,
      status:
        currentStep > 0
          ? currentStep > 1
            ? "completed"
            : "active"
          : "pending",
    },
    {
      number: 3,
      status:currentStep > 2
      ? "completed" : currentStep === 2
        ? "active"
      : "pending",
    },
  ];

  return (
    <div className={StepperStyles.customStepper}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div
            className={`${StepperStyles.stepCircle} ${
              StepperStyles[step.status]
            }`}
          >
            {step.status === "completed" ? (
              <CheckOutlined />
            ) : (
              <span>{step.number}</span>
            )}
          </div>

          {/* Add connector line after each circle except the last one */}
          {index < steps.length - 1 && (
            <div
              className={`${StepperStyles.stepConnector} ${
                currentStep > index
                  ? StepperStyles.completed
                  : StepperStyles.pending
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CustomStepper;
